<template>
  <div>
    <a-tabs v-model="queryForm.type" size="small" @change="changeTab">
      <a-tab-pane key="nuogua" tab="挪挂申请"></a-tab-pane>
      <a-tab-pane key="kongfan" tab="空返申请"></a-tab-pane>
      <a-tab-pane key="lindiao" tab="临调车申请"></a-tab-pane>
      <a-tab-pane key="jiangdun" tab="降吨结算申请"></a-tab-pane>
      <a-tab-pane key="borrow" tab="车辆借调申请"></a-tab-pane>
    </a-tabs>
    <!-- 通用搜索栏 -->
    <v-row class="mt-2 mb-2">
      <v-col cols="12" xl="3" lg="2" md="3" sm="6">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details></v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="3" lg="2" md="3" sm="6">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details></v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="3" lg="2" md="3" sm="6">
        <v-autocomplete v-model="queryForm.state" :items="stateOptions" label="审批状态"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense clearable hide-details>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="3" lg="2" md="3" sm="6">
        <a-space>
          <v-btn tile class="primary white--text" @click="getdata()">
            <v-icon small>mdi-magnify</v-icon> 查询
          </v-btn>
          <v-btn color="success" tile @click="showadd()">
            <v-icon small>mdi-plus</v-icon> 新增
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <v-card tile>
      <a-table size="small" :columns="headers" :data-source="list" :pagination="false" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: 1400, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ list.length }} 条数据</span>
          </div>
        </template>
        <!--临调-->
        <template slot="lindiao" slot-scope="text, record">
          <table class="lindiao-detail-table">
            <thead>
              <tr>
                <th>线路</th>
                <th>车型</th>
                <th>数量</th>
                <th>收入(/车/元)</th>
                <th>成本(/车/元)</th>
                <th>利润(/车/元)</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in record.lindiao" :key="idx">
                <td>{{ item.postline }}</td>
                <td>{{ item.vehicle_type }}</td>
                <td>{{ item.count }}</td>
                <td>{{ item.income }}</td>
                <td>{{ item.cost }}</td>
                <td class="profit">{{ item.profit }}</td>
                <td>{{ item.remark }}</td>
              </tr>
            </tbody>
          </table>
        </template>
        <!--挪挂-->
        <template slot="driver" slot-scope="text, record">
          <p>{{ record.driver_name }}</p>
          <p>{{ record.driver_mobile }}</p>
        </template>
        <!--挪挂-->
        <template slot="nuogua_state" slot-scope="text, record">
          <p :class="{
            'orange--text': record.nuogua_state === 'waiting',
            'primary--text': record.nuogua_state === 'accepted',
            'success--text': record.nuogua_state === 'finished',
          }">
            {{ record.nuogua_state === 'waiting' ? '未接单' : '' }}
            {{ record.nuogua_state === 'accepted' ? '已接单' : '' }}
            {{ record.nuogua_state === 'finished' ? '已完成' : '' }}
          </p>
        </template>
        <!--空返-->
        <template slot="isHighway" slot-scope="text, record">
          <a-tag v-if="record.isHighway" color="green">是</a-tag>
          <a-tag v-else>否</a-tag>
        </template>
        <!--空返-->
        <template slot="eocost" slot-scope="text, record">
          {{ record.ecost || record.ocost || 0 }}
        </template>
        <!--空返-->
        <template slot="tcost" slot-scope="text, record">
          <span class="font-weight-bold error--text">{{ record.tcost }}</span>
        </template>
        <!--空返-->
        <template slot="kongfan_state" slot-scope="text, record">
          <p :class="{
            'orange--text': record.kongfan_state === 'waiting',
            'primary--text': record.kongfan_state === 'accepted',
            'success--text': record.kongfan_state === 'finished',
          }">
            {{ record.kongfan_state === 'waiting' ? '未接单' : '' }}
            {{ record.kongfan_state === 'accepted' ? '已接单' : '' }}
            {{ record.kongfan_state === 'finished' ? '已完成' : '' }}
          </p>
        </template>
        <!--降吨-->
        <template slot="incomediff" slot-scope="text, record">
          <span class="error--text font-weight-bold">{{ record.incomediff }}</span>
        </template>
        <!--借调：所属区域-->
        <template slot="from_area" slot-scope="text">
          <span>{{ text || '--' }}</span>
        </template>
        <!--借调：借调区域-->
        <template slot="to_area" slot-scope="text">
          <span>{{ text || '--' }}</span>
        </template>
        <template slot="state" slot-scope="text, record">
          <a-tag v-if="record.state === 0">未审批</a-tag>
          <a-tag v-if="record.state === 1" color="green">已通过</a-tag>
          <a-tag v-if="record.state === 2" color="red">未通过</a-tag>
        </template>
        <template slot="approvalInfo" slot-scope="text, record">
          <div v-if="record.state !== 0" class="approval-info">
            <!-- <p v-if="record.approval_by">
              审批人: {{ record.approval_by }}
            </p> -->
            <p v-if="record.approval_time">
              时间: {{ record.approval_time }}
            </p>
            <p v-if="record.approval_remark" class="remark-text">
              意见: {{ record.approval_remark }}
            </p>
          </div>
          <span v-else class="grey--text">-</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn v-if="record.approvalable" text tile small color="primary" @click="showapproval(record)">审核</v-btn>
            <v-btn v-if="record.detailable" text tile small color="info" @click="showapproval(record)">详情</v-btn>
            <v-btn v-if="record.editable" text tile small color="warning" @click="showedit(record)">编辑</v-btn>
            <a-popconfirm v-if="record.removeable" title="确定删除该记录？" ok-text="确定" cancel-text="取消"
              @confirm="remove(record._id)">
              <v-btn text tile small color="error">删除</v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </v-card>
    <v-dialog v-model="approvalModel" :max-width="approvalForm.type === 'lindiao' ? 960 : 750">
      <v-form ref="approvalForm" v-model="approvalValid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ approvalTitle }}
            <v-icon @click="() => approvalModel = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:550px;overflow-y: auto;">
              <v-row>
                <v-col :cols="approvalForm.type === 'lindiao' ? 12 : 6">
                  <v-menu ref="date_menu" v-model="date_menu" :close-on-content-click="false"
                    :return-value.sync="approvalForm.date" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="approvalForm.date" :rules="[vrules.required]" label="日期" placeholder="选择日期"
                        append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" dense outlined hide-details>
                        <template v-slot:label>
                          日期 <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="approvalForm.date" type="date" no-title value="YYYY-mm-DD" scrollable
                      locale="zh-cn"
                      @input="() => { $refs.date_menu.save(approvalForm.date); date_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <template v-if="approvalForm.type === 'kongfan'">
                  <v-col cols="12">
                    <v-text-field v-model="approvalForm.postline" :rules="[vrules.required]" outlined dense>
                      <template v-slot:label>
                        线路<span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                </template>
                <template v-if="approvalForm.type === 'jiangdun'">
                  <v-col cols="12">
                    <v-autocomplete v-model="approvalForm.postlineid" :items="postlines" :rules="[vrules.required]"
                      label="线路" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense
                      @change="changePostline">
                      <template v-slot:label>
                        线路 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </template>
                <!--挪挂申请-->
                <template v-if="approvalForm.type === 'nuogua'">
                  <v-col cols="12">
                    <v-autocomplete v-model="approvalForm.vehicleid" :items="vehicles" :rules="[vrules.required]"
                      label="车牌号" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                      <template v-slot:label>
                        车牌号 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="approvalForm.gvehicleid" :items="gvehicles" :rules="[vrules.required]"
                      label="挂厢号" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                      <template v-slot:label>
                        挂厢号 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="approvalForm.driverid" :items="drivers" :rules="[vrules.required]"
                      label="司机" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                      <template v-slot:label>
                        司机 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="approvalForm.remark" label="备注" textarea outlined dense>
                    </v-text-field>
                  </v-col>
                </template>
                <!--空返申请-->
                <template v-if="approvalForm.type === 'kongfan'">
                  <v-col cols="12">
                    <v-autocomplete v-model="approvalForm.vehicleid" :items="vehicles" :rules="[vrules.required]"
                      label="车牌号" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                      <template v-slot:label>
                        车牌号 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="approvalForm.driverid" :items="drivers" :rules="[vrules.required]"
                      label="司机" :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                      <template v-slot:label>
                        司机 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-select v-model="approvalForm.isHighway" :items="highwayOptions"
                      :menu-props="{ bottom: true, offsetY: true }" outlined dense>
                      <template v-slot:label>
                        是否高速 <span class="red--text">*</span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="approvalForm.km" type="number" :rules="[vrules.required]" suffix="KM"
                      outlined dense>
                      <template v-slot:label>
                        里程(KM) <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="approvalForm.remark" label="备注（空返理由、走高速理由）" textarea outlined dense>
                    </v-text-field>
                  </v-col>
                </template>
                <!--降吨申请-->
                <template v-if="approvalForm.type === 'jiangdun'">
                  <v-col cols="12">
                    <v-autocomplete v-model="approvalForm.vehicle_type" :items="vehicle_types2"
                      :rules="[vrules.required]" label="使用车型" :menu-props="{ bottom: true, offsetY: true }"
                      no-data-text="无" outlined dense @change="changeVehicleType">
                      <template v-slot:label>
                        使用车型 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete v-model="approvalForm.fee_vehicle_type" :items="vehicle_types2"
                      :rules="[vrules.required]" label="结算车型" :menu-props="{ bottom: true, offsetY: true }"
                      no-data-text="无" outlined dense @change="changeFeeVehicleType">
                      <template v-slot:label>
                        结算车型 <span class="red--text">*</span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model.number="approvalForm.incomediff" type="number" :rules="[vrules.required]"
                      outlined dense>
                      <template v-slot:label>
                        收入差（元）<span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="approvalForm.remark" label="备注（降吨结算理由）" textarea outlined dense>
                    </v-text-field>
                  </v-col>
                </template>
                <!--临调申请-->
                <template v-if="approvalForm.type === 'lindiao'">
                  <template v-for="(item, index) in approvalForm.lindiao">
                    <v-col cols="3" :key="index + '_1'">
                      <v-autocomplete v-model="item.postlineid" :items="postlines" label="线路"
                        :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense hide-details>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="2" :key="index + '_2'">
                      <v-autocomplete v-model="item.vehicle_type" :items="vehicle_types" label="车型"
                        :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense hide-details>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="2" :key="index + '_3'">
                      <v-text-field v-model.number="item.count" type="number" label="数量" outlined dense hide-details>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" :key="index + '_4'">
                      <v-text-field v-model="item.remark" label="备注" outlined dense hide-details>
                      </v-text-field>
                    </v-col>
                    <v-col cols="1" :key="index + '_5'">
                      <v-btn v-if="index === 0" icon small @click="addlindiao">
                        <v-icon class="success--text">mdi-plus-circle</v-icon>
                      </v-btn>
                      <v-btn v-else icon small @click="removelindiao(index)">
                        <v-icon class="error--text">mdi-minus-circle</v-icon>
                      </v-btn>
                    </v-col>
                  </template>
                </template>
                <!--车辆借调申请-->
                <template v-if="approvalForm.type === 'borrow'">
                  <v-col cols="12">
                    <v-text-field v-model="approvalForm.vehicle_number" :rules="[vrules.required]" label="车牌号"
                      outlined dense>
                      <template v-slot:label>
                        车牌号 <span class="red--text">*</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select v-model="approvalForm.from_area" :items="areas" :rules="[vrules.required]" label="所属区域"
                      :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                      <template v-slot:label>
                        所属区域 <span class="red--text">*</span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select v-model="approvalForm.to_area" :items="areas" :rules="[vrules.required]" label="借调区域"
                      :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense>
                      <template v-slot:label>
                        借调区域 <span class="red--text">*</span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field v-model="approvalForm.remark" label="备注" textarea outlined dense>
                    </v-text-field>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile class="primary white--text" @click="save">提交申请</v-btn>
            <v-btn tile @click="() => approvalModel = false">取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- 审批详情弹窗 -->
    <v-dialog v-model="approvalResultModel" max-width="520" persistent scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          {{ approvalResultTitle }}
        </v-card-title>
        <v-card-text class="pt-4">
          <!-- 已审批：展示审批信息 -->
          <div v-if="approvalResultForm.state !== 0">
            <a-descriptions :column="1" bordered size="small">
              <a-descriptions-item label="审批时间">
                {{ approvalResultForm.approval_time }}
              </a-descriptions-item>
              <a-descriptions-item label="审批意见">
                {{ approvalResultForm.approval_remark || '-' }}
              </a-descriptions-item>
            </a-descriptions>
          </div>
          <!-- 未审批：审批操作 -->
          <template v-else>
            <v-radio-group v-model="approvalResultForm.approval_state" row hide-details>
              <v-radio color="success" label="审批通过" :value="1"></v-radio>
              <v-radio color="error" label="审批不通过" :value="2"></v-radio>
            </v-radio-group>
            <v-textarea v-model="approvalResultForm.approval_remark" label="审批意见" dense outlined rows="3"
              class="mt-3"></v-textarea>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text tile @click="() => approvalResultModel = false">
            {{ approvalResultForm.state === 0 ? '取消' : '关闭' }}
          </v-btn>
          <v-btn v-if="approvalResultForm.state === 0" color="primary" dark tile @click="confirmApprove">
            {{ approvalResultForm.approval_state === 2 ? '确认不通过' : '审批通过' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Approval',
  data() {
    return {
      queryForm: {
        type: "lindiao",
        start_day: "",
        end_day: "",
        state: null,
      },
      start_day_menu: false,
      end_day_menu: false,
      list: [],
      height: 500,
      approvalForm: {
        lindiao: []
      },
      approvalTitle: "",
      approvalModel: false,
      postlines: [],
      vehicles: [],
      gvehicles: [],
      drivers: [],
      vehicle_types: [],
      postlinecontracts: [],
      approvalValid: true,
      date_menu: false,
      vrules: {
        required: (value) => !!value || "不能为空",
      },
      approvalResultTitle: '',
      approvalResultModel: false,
      approvalResultForm: {},
      // 状态选项
      stateOptions: [
        { value: 0, text: '未审批' },
        { value: 1, text: '已通过' },
        { value: 2, text: '未通过' },
      ],
      // 是否高速选项
      highwayOptions: [
        { value: true, text: '是' },
        { value: false, text: '否' },
      ],
      // 区域选项
      areas: ['南信周', '商丘开封', '安濮鹤新', '机动车辆', '洛焦济三', '漯平许驻', '豫东豫北'],
      // 区域颜色
      areacolors: {
        '南信周': '#D84141',
        '商丘开封': '#D8C341',
        '安濮鹤新': '#6CD841',
        '机动车辆': '#41D897',
        '洛焦济三': '#4197D8',
        '漯平许驻': '#6C41D8',
        '豫东豫北': '#D841C3',
      },
    };
  },
  computed: {
    ...mapState(['username']),
    headers() {
      return [
        { dataIndex: 'date', title: '日期', width: 100, align: 'center' },
        ...(this.queryForm.type === 'nuogua' ? [
          { dataIndex: 'vehicle_number', title: '车牌号', width: 120, align: 'center', scopedSlots: { customRender: 'vehicle_number' } },
          { dataIndex: 'vehicle_gnumber', title: '挂箱号', width: 120, align: 'center', scopedSlots: { customRender: 'vehicle_gnumber' } },
          { dataIndex: 'driver', title: '司机', width: 120, align: 'center', scopedSlots: { customRender: 'driver' } },
          { dataIndex: 'create_by', title: '提交人', width: 100, align: 'center', scopedSlots: { customRender: 'create_by' } },
          { dataIndex: 'create_time', title: '创建时间', width: 150, align: 'center', scopedSlots: { customRender: 'create_time' } },
          { dataIndex: 'remark', title: '备注', width: 150, align: 'center', scopedSlots: { customRender: 'remark' } },
          { dataIndex: 'nuogua_state', title: '任务状态', width: 100, align: 'center', scopedSlots: { customRender: 'nuogua_state' } },
          { dataIndex: 'action', title: '操作', width: 180, align: 'center', scopedSlots: { customRender: 'action' } },
        ] : []),
        ...(this.queryForm.type === 'kongfan' ? [
          { dataIndex: 'postline', title: '线路', width: 100, align: 'center', scopedSlots: { customRender: 'postline' } },
          { dataIndex: 'vehicle_number', title: '车牌号', width: 100, align: 'center', scopedSlots: { customRender: 'vehicle_number' } },
          { dataIndex: 'driver', title: '司机', width: 120, align: 'center', scopedSlots: { customRender: 'driver' } },
          { dataIndex: 'isHighway', title: '高速', width: 50, align: 'center', scopedSlots: { customRender: 'isHighway' } },
          { dataIndex: 'km', title: '里程(KM)', width: 80, align: 'center', scopedSlots: { customRender: 'km' } },
          { dataIndex: 'eocost', title: '电/油费(元)', width: 100, align: 'center', scopedSlots: { customRender: 'eocost' } },
          { dataIndex: 'rcost', title: '过路费(元)', width: 100, align: 'center', scopedSlots: { customRender: 'rcost' } },
          { dataIndex: 'tcost', title: '空返成本(元)', width: 100, align: 'center', scopedSlots: { customRender: 'tcost' } },
          { dataIndex: 'create_by', title: '提交人', width: 80, align: 'center', scopedSlots: { customRender: 'create_by' } },
          { dataIndex: 'create_time', title: '创建时间', width: 120, align: 'center', scopedSlots: { customRender: 'create_time' } },
          { dataIndex: 'state', title: '状态', width: 80, align: 'center', scopedSlots: { customRender: 'state' } },
          { dataIndex: 'approvalInfo', title: '审批', width: 80, align: 'center', scopedSlots: { customRender: 'approvalInfo' } },
          { dataIndex: 'remark', title: '备注', width: 100, align: 'center', scopedSlots: { customRender: 'remark' } },
          { dataIndex: 'action', title: '操作', width: 100, align: 'center', scopedSlots: { customRender: 'action' } },
        ] : []),
        ...(this.queryForm.type === 'lindiao' ? [
          { dataIndex: 'lindiao', title: '临调车信息', align: 'center', scopedSlots: { customRender: 'lindiao' } },
          { dataIndex: 'create_by', title: '提交人', width: 100, align: 'center', scopedSlots: { customRender: 'create_by' } },
          { dataIndex: 'create_time', title: '创建时间', width: 120, align: 'center', scopedSlots: { customRender: 'create_time' } },
          { dataIndex: 'state', title: '状态', width: 100, align: 'center', scopedSlots: { customRender: 'state' } },
          { dataIndex: 'approvalInfo', title: '审批信息', width: 150, align: 'center', scopedSlots: { customRender: 'approvalInfo' } },
          { dataIndex: 'action', title: '操作', width: 180, align: 'center', scopedSlots: { customRender: 'action' } },
        ] : []),
        ...(this.queryForm.type === 'jiangdun' ? [
          { dataIndex: 'postline', title: '线路', width: 150, align: 'center', scopedSlots: { customRender: 'postline' } },
          { dataIndex: 'vehicle_type', title: '使用车型', width: 120, align: 'center', scopedSlots: { customRender: 'vehicle_type' } },
          { dataIndex: 'fee_vehicle_type', title: '结算车型', width: 120, align: 'center', scopedSlots: { customRender: 'fee_vehicle_type' } },
          { dataIndex: 'incomediff', title: '收入(元)', width: 120, align: 'center', scopedSlots: { customRender: 'incomediff' } },
          { dataIndex: 'create_by', title: '提交人', width: 100, align: 'center', scopedSlots: { customRender: 'create_by' } },
          { dataIndex: 'create_time', title: '创建时间', width: 150, align: 'center', scopedSlots: { customRender: 'create_time' } },
          { dataIndex: 'state', title: '状态', width: 100, align: 'center', scopedSlots: { customRender: 'state' } },
          { dataIndex: 'approvalInfo', title: '审批信息', width: 150, align: 'center', scopedSlots: { customRender: 'approvalInfo' } },
          { dataIndex: 'remark', title: '备注', width: 100, align: 'center', scopedSlots: { customRender: 'remark' } },
          { dataIndex: 'action', title: '操作', width: 180, align: 'center', scopedSlots: { customRender: 'action' } },
        ] : []),
        ...(this.queryForm.type === 'borrow' ? [
          { dataIndex: 'vehicle_number', title: '车牌号', width: 120, align: 'center' },
          { dataIndex: 'from_area', title: '所属区域', width: 110, align: 'center', scopedSlots: { customRender: 'from_area' } },
          { dataIndex: 'to_area', title: '借调区域', width: 110, align: 'center', scopedSlots: { customRender: 'to_area' } },
          { dataIndex: 'create_by', title: '提交人', width: 100, align: 'center' },
          { dataIndex: 'create_time', title: '创建时间', width: 160, align: 'center' },
          { dataIndex: 'state', title: '状态', width: 90, align: 'center', scopedSlots: { customRender: 'state' } },
          { dataIndex: 'approvalInfo', title: '审批信息', width: 150, align: 'center', scopedSlots: { customRender: 'approvalInfo' } },
          { dataIndex: 'remark', title: '备注', width: 200, align: 'center' },
          { dataIndex: 'action', title: '操作', width: 180, align: 'center', scopedSlots: { customRender: 'action' } },
        ] : []),
      ];
    },
    vehicle_types2() {
      if (this.approvalForm.type === 'jiangdun') {
        return this.postlinecontracts.filter(n => n.postlineid === this.approvalForm.postlineid).map(n => ({ value: n.vehicle_type, text: n.vehicle_type }));
      }
      return [];
    },
  },
  mounted() {
    this.height = window.innerHeight - 350;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 350;
    };
    // 搜索栏日期默认当天
    const today = this.$moment().format('YYYY-MM-DD');
    this.queryForm = {
      type: "lindiao",
      start_day: today,
      end_day: today,
      state: null,
    };
    this.getdata();
  },
  methods: {
    init() {
      this.getdata();
    },
    changeTab(value) {
      console.log('changeTab', value);
      this.getdata();
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchapproval/list", { ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.info(null, this.queryForm.type).then(data => {
        if (data) {
          this.postlines = data.postlines;
          this.vehicles = data.vehicles;
          this.gvehicles = data.gvehicles;
          this.drivers = data.drivers;
          this.vehicle_types = data.vehicle_types;
          this.postlinecontracts = data.postlinecontracts;
          this.approvalForm = data.form;
          this.approvalTitle = data.title;
          this.approvalModel = true;
        }
      });
    },
    showedit(item) {
      this.info(item._id, item.type).then(data => {
        if (data) {
          this.postlines = data.postlines;
          this.vehicles = data.vehicles;
          this.gvehicles = data.gvehicles;
          this.drivers = data.drivers;
          this.vehicle_types = data.vehicle_types;
          this.postlinecontracts = data.postlinecontracts;
          this.approvalForm = data.form;
          this.approvalTitle = data.title;
          this.approvalModel = true;
        }
      });
    },
    info(_id, type) {
      this.$toast.loading({ message: "" });
      return this.$api.doAPI("/dispatchapproval/info", { _id, type }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          return res.data;
        }
        else {
          this.$alert(res.msg);
          return null;
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
        return null;
      });
    },
    addlindiao() {
      this.approvalForm.lindiao.push({
        postlineid: "",
        vehicle_type: "",
        count: 0,
        remark: "",
      });
    },
    removelindiao(index) {
      this.approvalForm.lindiao.splice(index, 1);
    },
    save() {
      if (!this.$refs.approvalForm.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchapproval/save", { dataForm: this.approvalForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.approvalModel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    changePostline(v) {
      let contract = this.postlinecontracts.find(n => n.postlineid === v);
      this.$set(this.approvalForm, 'km', contract?.km || "");
    },
    //降吨 使用车型
    changeVehicleType(v) {
      console.log('changeVehicleType', v);
      let contract = this.postlinecontracts.find(n => n.postlineid === this.approvalForm.postlineid && n.vehicle_type === v);
      this.$set(this.approvalForm, 'income1', contract?.price || "0");
      if (this.approvalForm.income1 && this.approvalForm.income2) {
        this.$set(this.approvalForm, 'incomediff', this.$d(this.approvalForm.income2).minus(this.approvalForm.income1).toString());
      }
    },
    //降吨 结算车型
    changeFeeVehicleType(v) {
      console.log('changeFeeVehicleType', v);
      let contract = this.postlinecontracts.find(n => n.postlineid === this.approvalForm.postlineid && n.vehicle_type === v);
      this.$set(this.approvalForm, 'income2', contract?.price || "0");
      if (this.approvalForm.income1 && this.approvalForm.income2) {
        this.$set(this.approvalForm, 'incomediff', this.$d(this.approvalForm.income2).minus(this.approvalForm.income1).toString());
      }
    },
    showapproval(item) {
      if (item.type === 'lindiao') {
        this.approvalResultTitle = '临调车审批详情';
      }
      else if (item.type === 'kongfan') {
        this.approvalResultTitle = '空返审批详情';
      }
      else if (item.type === 'jiangdun') {
        this.approvalResultTitle = '降吨审批详情';
      }
      else if (item.type === 'borrow') {
        this.approvalResultTitle = '车辆借调审批详情';
      }
      this.approvalResultForm = {
        _id: item._id,
        type: item.type,
        state: item.state,
        approval_state: 1,
        approval_by: item.approval_by,
        approval_time: item.approval_time,
        approval_remark: item.approval_remark || "",
      };
      this.approvalResultModel = true;
    },
    confirmApprove() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchapproval/confirm", { dataForm: this.approvalResultForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.approvalResultModel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/dispatchapproval/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.red--text {
  color: #f5222d !important;
}

.grey--text {
  color: #999 !important;
}

/* 临调车明细表格样式 */
.lindiao-detail-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.lindiao-detail-table th,
.lindiao-detail-table td {
  border: 1px solid #e8e8e8;
  padding: 6px 8px;
  text-align: left;
}

.lindiao-detail-table th {
  background: #fafafa;
  font-weight: 500;
  color: #666;
}

.lindiao-detail-table .profit {
  color: #f5222d;
  font-weight: bold;
}

/* 审批信息样式 */
.approval-info {
  font-size: 12px;
  line-height: 1.8;
}

.approval-info .remark-text {
  color: #666;
  margin-top: 2px;
}

p {
  margin: 0;
}
</style>
